import { BrandThemeProvider } from '@collaborate-health/uikit'

const TenantThemeProvider = ({ children }: { children: React.ReactNode }) => {
  // TODO: Select colors from tenant config and provide them as props

  return <BrandThemeProvider>{children}</BrandThemeProvider>
}

export default TenantThemeProvider

